import React, { useState, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { makeStyles, fade } from '@material-ui/core/styles'

import UserMgmtListUsers from './UserMgmtListUsers'
import UserMgmtUserMOD from './UserMgmtUserMOD'
import UserMgmtBatch from './UserMgmtBatch'
import UserMgmtBatchCreate from './UserMgmtBatchCreate'

import { handleParserCSV } from '../../../../utils'

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 350,
    maxWidth: 350
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  singleChip: {
    width: '85%'
  },
  noLabel: {
    marginTop: theme.spacing(3)
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#A4D164'
    }
  },
  cssFocused: {},
  csvUploadBtn: {
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#719E31'
    }
  },
  userCard: {
    width: '100%'
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  userCardContainer: {
    maxHeight: '35em',
    overflow: 'scroll'
  },
  roleItem: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '75%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  supervisorContainer: {
    maxHeight: '37em',
    width: '100%',
    padding: theme.spacing(2, 0),
    marginLeft: 'auto',
    marginRight: 'auto',
    // overflowX: 'hidden',
    overflowY: 'scroll'
  },
  roleBtn: {
    paddingLeft: '0.5em',
    paddingRight: '0.5em'
  },
  errorLight: {
    backgroundColor: '#f0ad4e',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#BD7A1B'
    }
  },
  successLight: {
    backgroundColor: '#719E31',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#3E6B00',
      color: '#fff'
    }
  },
  selectedRole: {
    color: '#719E31'
  },
  unselectedRole: {
    color: theme.palette.text.secondary
  },
  ouBtn: {
    paddingLeft: '0.5em',
    paddingRight: '0.5em'
  },
  ouPopper: {
    zIndex: '1051 !important',
    marginBottom: theme.spacing(1)
  },
  ouPaper: {
    padding: theme.spacing(1),
    width: '100%',
    height: 'fit-content'
  }
}))

/**
 * Returns user management forms
 */
const UserMgmtUsers = (props) => {
  const classes = useStyles()

  const userRoleSupervisors = useSelector(state => state.userListings.userRoleSupervisors)
  const userRoles = useSelector(state => state.userRoles.userRoles)

  const [fileName, setFileName] = useState('Choose CSV File to Upload')
  const [fileUpload, setFileUpload] = useState(null)
  const [btnStats, setBtnStats] = useState({
    csvUploadStat: true,
    userDataStat: true
  })
  const [parsedUsers, setParsedUsers] = useState([])

  const [usersListFormSwap, setUsersListFormSwap] = useState('list')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [title, setTitle] = useState('')
  const [email, setEmail] = useState('')
  const [cell, setCell] = useState('')
  const [roleID, setRoleID] = useState('')
  const [units, setUnits] = useState([])
  const [roleName, setRoleName] = useState('')
  const [supervisorID, setSupervisorID] = useState('')

  const [usersInfo, setUsersInfo] = useState([])
  const [roles, setRoles] = useState([])

  useEffect(() => {
    if (userRoleSupervisors) {
      const userSupervisorList = []
      userRoleSupervisors.forEach((roleSup) => {
        const mappedRoleSups = roleSup.roleSupervisors.map((supervisor) => {
          return {
            ...supervisor,
            role: roleSup.roleName,
            roleID: roleSup.roleID
          }
        })
        userSupervisorList.push(...mappedRoleSups)
      })
      setUsersInfo(userSupervisorList)
    }
  }, [userRoleSupervisors])

  useEffect(() => {
    if (userRoles) {
      setRoles(userRoles.map((role) => {
        return {
          roleID: role.roleID,
          roleName: role.roleName,
          rolePermission: role.rolePermissions
        }
      }))
    }
  }, [userRoles])

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  }

  const swapForms = () => {
    switch (usersListFormSwap) {
      case 'list':
        return (
          <UserMgmtListUsers
            usersInfo={usersInfo}
            handleNewSwap={handleNewSwap}
            handleBatchSwap={handleBatchSwap}
            handleEditSwap={handleEditSwap}
            classes={classes}
          />
        )
      case 'edit':
        return (
          <UserMgmtUserMOD
            firstName={firstName}
            lastName={lastName}
            jobTitle={title}
            cellPhone={cell}
            emailAddress={email}
            roleID={roleID}
            units={units}
            roleName={roleName}
            onBackTrack={handleListSwap}
            onSuccess={handleListSwap}
            roles={roles}
            userRoles={userRoles}
            MODsupervisorID={supervisorID}
            classes={classes}
            MenuProps={MenuProps}
            type={usersListFormSwap}
          />
        )
      case 'new':
        return (
          <UserMgmtUserMOD
            firstName={firstName}
            lastName={lastName}
            jobTitle={title}
            cellPhone={cell}
            emailAddress={email}
            roleID={roleID}
            units={units}
            roleName={roleName}
            onBackTrack={handleListSwap}
            onSuccess={handleListSwap}
            roles={roles}
            userRoles={userRoles}
            MODsupervisorID={supervisorID}
            classes={classes}
            MenuProps={MenuProps}
            type={usersListFormSwap}
          />
        )
      case 'batch':
        return (
          <UserMgmtBatch
            onBackBatchUpload={handleBackToList}
            onUploadCSV={handleUploadCSV}
            onBatchUploadCSV={handleBatchUploadCSV}
            onBatchUploadData={handleBatchUploadData}
            fileName={fileName}
            btnStats={btnStats}
          />
        )
      case 'batch-users':
        return (
          <UserMgmtBatchCreate
            onBackBatchUsers={handleBackUpload}
            batchUsers={parsedUsers}
            usersInfo={usersInfo}
            roles={roles}
            onSuccess={batchUserSuccess}
          />
        )
      case 'batch-data':
        return (
          <UserMgmtBatchCreate
            onBackBatchUsers={handleBackUpload}
            usersInfo={usersInfo}
            roles={roles}
            onSuccess={batchUserSuccess}
          />
        )
      default:
        return null
    }
  }

  const batchUserSuccess = () => {
    setUsersListFormSwap('list')
  }

  const handleBackToList = (e) => {
    e.preventDefault()
    setUsersListFormSwap('list')
    setFileName('')
    setFileUpload('')
    setBtnStats({
      csvUploadStat: true,
      userDataStat: true
    })
  }

  const setEditData = (userInfo) => {
    setFirstName(userInfo.firstName)
    setLastName(userInfo.lastName)
    setTitle(userInfo.jobTitle)
    setEmail(userInfo.emailAddress)
    setCell(userInfo.officePhone)
    setRoleID(userInfo.roleID)
    setSupervisorID(userInfo.supervisorID)
    setUnits(userInfo.units)

    const roleIndex = userRoles.findIndex((userRole) => {
      return userRole.roleID === userInfo.roleID
    })
    setRoleName(userRoles[roleIndex].roleName)
  }

  const handleBackUpload = (e) => {
    e.preventDefault()
    setUsersListFormSwap('batch')
  }

  const handleUploadCSV = (e) => {
    const [file] = e.target.files
    if (file !== undefined) {
      const extIndex = file.name.indexOf('.csv')
      if (extIndex !== -1) {
        setFileName(file.name)
        const reader = new window.FileReader()

        reader.onload = (e) => {
          const result = e.target.result
          setFileUpload(result)
          setBtnStats({ ...btnStats, csvUploadStat: false })
        }

        reader.readAsText(file)
      }
    }
  }

  const handleBatchUploadCSV = () => {
    const parsedCSV = handleParserCSV(fileUpload)
    setParsedUsers(parsedCSV)
    setUsersListFormSwap('batch-users')
  }

  const handleBatchUploadData = () => {
    setUsersListFormSwap('batch-data')
  }

  const handleNewSwap = () => {
    setUsersListFormSwap('new')
  }

  const handleEditSwap = (userInfo) => {
    setUsersListFormSwap('edit')
    setEditData(userInfo)
  }

  const handleListSwap = () => {
    clearFields()
    setUsersListFormSwap('list')
  }

  const handleBatchSwap = () => {
    setUsersListFormSwap('batch')
  }

  const clearFields = () => {
    setFirstName('')
    setLastName('')
    setTitle('')
    setEmail('')
    setCell('')
    setRoleName('')
    setRoleID('')
    setUnits([])
    setFileName('Choose CSV File to Upload')
    setSupervisorID('')
  }

  return (
    <>
      {swapForms()}
    </>
  )
}

export default UserMgmtUsers
